/**
 * Utilitaire de fonctions réutilisables
 * Un peu fourre-tout :(
 */

import { EXIF } from "exif-js";
import * as PDFJS from "pdfjs-dist/build/pdf";
import { CURRENCY_SYMBOL } from "./constants";
import XLSX from 'xlsx';
import moment from "moment";

export function clone(obj) {
    if (null === obj || "object" !== typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
}

export function tryParseInt(str, defaultValue) {
    var retValue = defaultValue;
    if (str !== null) {
        if (str.length > 0) {
            if (!isNaN(str)) {
                retValue = parseInt(str, 10);
            }
        }
    }

    return retValue;
}

export function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return (
        s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4()
    );
}

export function checkEmailFormat(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
    return re.test(String(email).toLowerCase());
}

/* eslint-disable */
export function getBase64ImageWithHeader(image) {
    // var Base64 = { _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", encode: function (e) { var t = ""; var n, r, i, s, o, u, a; var f = 0; e = Base64._utf8_encode(e); while (f < e.length) { n = e.charCodeAt(f++); r = e.charCodeAt(f++); i = e.charCodeAt(f++); s = n >> 2; o = (n & 3) << 4 | r >> 4; u = (r & 15) << 2 | i >> 6; a = i & 63; if (isNaN(r)) { u = a = 64 } else if (isNaN(i)) { a = 64 } t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a) } return t }, decode: function (e) { var t = ""; var n, r, i; var s, o, u, a; var f = 0; e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""); while (f < e.length) { s = this._keyStr.indexOf(e.charAt(f++)); o = this._keyStr.indexOf(e.charAt(f++)); u = this._keyStr.indexOf(e.charAt(f++)); a = this._keyStr.indexOf(e.charAt(f++)); n = s << 2 | o >> 4; r = (o & 15) << 4 | u >> 2; i = (u & 3) << 6 | a; t = t + String.fromCharCode(n); if (u != 64) { t = t + String.fromCharCode(r) } if (a != 64) { t = t + String.fromCharCode(i) } } t = Base64._utf8_decode(t); return t }, _utf8_encode: function (e) { e = e.replace(/\r\n/g, "\n"); var t = ""; for (var n = 0; n < e.length; n++) { var r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r) } else if (r > 127 && r < 2048) { t += String.fromCharCode(r >> 6 | 192); t += String.fromCharCode(r & 63 | 128) } else { t += String.fromCharCode(r >> 12 | 224); t += String.fromCharCode(r >> 6 & 63 | 128); t += String.fromCharCode(r & 63 | 128) } } return t }, _utf8_decode: function (e) { var t = ""; var n = 0; var r = 0, c1 = 0, c2 = 0; while (n < e.length) { r = e.charCodeAt(n); if (r < 128) { t += String.fromCharCode(r); n++ } else if (r > 191 && r < 224) { c2 = e.charCodeAt(n + 1); t += String.fromCharCode((r & 31) << 6 | c2 & 63); n += 2 } else { c2 = e.charCodeAt(n + 1); var c3 = e.charCodeAt(n + 2); t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63); n += 3 } } return t } }

    // var decoded = Base64.decode(image);
    const imagePrefix = "data:image";
    const defaultImagePrefix = imagePrefix + ";base64,";

    if (image.startsWith(imagePrefix)) return image;

    return defaultImagePrefix + image;
}

export function formatAddress(address) {
    let strAddress = "";
    strAddress = address.street.concat(
        address.street2 ? " - ".concat(address.street2) : ""
    );
    strAddress = strAddress.concat("\r\n");
    strAddress = strAddress.concat(address.zip + " - " + address.city);
    return strAddress;
}

export function mobileAndTabletCheck() {
    var check = false;
    (function (a) {
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
                a
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4)
            )
        )
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

export function loadEXIF(img) {
    return new Promise((resolve, reject) => {
        EXIF.getData(img, function () {
            var tags = EXIF.getAllTags(this);

            return resolve({
                rotate: tags.Orientation,
            });
        });
    });
}

export async function convertPdfToImages(file, canvasElement) {
    let pdfUrl = URL.createObjectURL(file);

    return await PDFJS.getDocument({ url: pdfUrl }).promise.then(async (pdf) => {
        return await pdf.getPage(1).then(async (page) => {
            var viewport = page.getViewport({ scale: 1 });
            canvasElement.height = viewport.height;
            canvasElement.width = viewport.width;

            let ctx = canvasElement.getContext("2d");
            var renderContext = { canvasContext: ctx, viewport: viewport };

            await page.render(renderContext).promise
            return canvasElement.toDataURL()
        });
    });
}

export function resizeImage(file, imageElement, canvasElement) {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onload = () => {
            imageElement.src = reader.result;
            imageElement.onload = async () => {
                var originalCtx = canvasElement.getContext("2d");
                originalCtx.drawImage(imageElement, 0, 0);
                let { rotate = 1 } = await loadEXIF(imageElement);

                var MAX_WIDTH = 1920;
                // var MAX_HEIGHT = 1080;
                var width = imageElement.naturalWidth;
                var height = imageElement.naturalHeight;

                originalCtx = canvasElement.getContext("2d");

                let scale = width > height ? MAX_WIDTH / width : MAX_WIDTH / height;
                if (scale > 1) scale = 1;

                let dw = width * scale;
                let dh = height * scale;

                canvasElement.width = rotate > 4 ? dh : dw;
                canvasElement.height = rotate > 4 ? dw : dh;

                let x = canvasElement.width / 2;
                let y = canvasElement.height / 2;

                originalCtx.translate(x, y);

                // mirror
                switch (rotate) {
                    case 2:
                    case 4:
                    case 5:
                    case 7:
                        originalCtx.scale(-1, 1);
                        break;
                }

                if (rotate > 4) {
                    [x, y] = [y, x];
                }

                originalCtx.drawImage(imageElement, -x, -y, dw, dh);

                var dataUrl = canvasElement.toDataURL("image/jpeg", 0.5);
                return resolve(dataUrl);
            };
        };

        reader.onerror = (error) => {
            return reject(error);
        };

        reader.readAsDataURL(file);
    });
}

export function distinct(value, index, self) {
    return self.indexOf(value) === index;
}

export function getBestFontColor(colorAsHexa) {

    let colorAsRGB = hexToRgb(colorAsHexa);

    var o = Math.round(((parseInt(colorAsRGB.r) * 299) +
        (parseInt(colorAsRGB.g) * 587) +
        (parseInt(colorAsRGB.b) * 114)) /
        1000);

    return (o > 125) ? "#000000" : "#F5F6F5";
}

function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        }
        : null;
}

export function formatAmountToString(amount) {
    return amount.toLocaleString('fr', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }) + " " + CURRENCY_SYMBOL
}

export function downloadFile(fileURL, fileName) {
	// for non-IE
	if (!window.ActiveXObject) {
		var save = document.createElement("a");
		save.href = fileURL;
		save.target = "_blank";
		var filename = fileURL.substring(fileURL.lastIndexOf("/") + 1);
		save.download = fileName || filename;
		save.click();
	}
	// for IE < 11
	else if (!!window.ActiveXObject && document.execCommand) {
		var _window = window.open(fileURL, "_blank");
		_window.document.close();
		_window.document.execCommand("SaveAs", true, fileName || fileURL);
		_window.close();
	}
}

export function downloadReactTableAsXlsx(data, columns, fileName) {
    var dataToDownload = [];
    var headerRow = [];

    for (var colIndex = 0; colIndex < columns.length; colIndex++) {
        headerRow.push(columns[colIndex].Header)
    }

    dataToDownload.push(headerRow);

    for (var index = 0; index < data.length; index++) {
        let currentRow = [];

        for (colIndex = 0; colIndex < columns.length; colIndex++) {
            if (typeof columns[colIndex].accessor === "function") {
                let currentColumn = columns[colIndex];
                let currentValue = currentColumn.accessor(data[index])
                currentRow.push(currentValue)
            }
            else
                currentRow.push(data[index][columns[colIndex].accessor])
        }

        dataToDownload.push(currentRow);
    }

    var worksheet = XLSX.utils.aoa_to_sheet(dataToDownload);
    var new_workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(new_workbook, worksheet, fileName);
    XLSX.writeFile(new_workbook, fileName + ".xlsx");
}

export function defaultTableSortComparator(a, b, desc) {
	// force null and undefined to the bottom
	a = a === null || a === undefined ? '' : a
	b = b === null || b === undefined ? '' : b
	// force any string values to lowercase
	a = typeof a === 'string' ? a.toLowerCase() : a
	b = typeof b === 'string' ? b.toLowerCase() : b

	if (moment.isMoment(a) && moment.isMoment(b)) {
		// Return either 1 or -1 to indicate a sort priority
		if (desc ? a.isAfter(b) : a.isBefore(b)) {
			return -1
		} else if (desc ? a.isBefore(b) : a.isAfter(b)) {
			return 1
		}
	} else {
		// Return either 1 or -1 to indicate a sort priority
		if (desc ? a > b : a < b) {
			return 1
		} else if (desc ? a < b : a > b) {
			return -1
		}
	}

	// returning 0, undefined or any falsey value will use subsequent sorts or
	// the index as a tiebreaker
	return 0
}

export function sortListOfTableBy(attribute, desc, list) {
	return list.sort((a, b) => defaultTableSortComparator(a[attribute], b[attribute], desc))
}

export function deepCompare () {
    var i, l, leftChain, rightChain;

    function compare2Objects(x, y) {
        var p;

        // remember that NaN === NaN returns false
        // and isNaN(undefined) returns true
        if (isNaN(x) && isNaN(y) && typeof x === 'number' && typeof y === 'number') {
            return true;
        }

        // Compare primitives and functions.
        // Check if both arguments link to the same object.
        // Especially useful on the step where we compare prototypes
        if (x === y) {
            return true;
        }

        // Works in case when functions are created in constructor.
        // Comparing dates is a common scenario. Another built-ins?
        // We can even handle functions passed across iframes
        if ((typeof x === 'function' && typeof y === 'function') ||
            (x instanceof Date && y instanceof Date) ||
            (x instanceof RegExp && y instanceof RegExp) ||
            (x instanceof String && y instanceof String) ||
            (x instanceof Number && y instanceof Number)) {
            return x.toString() === y.toString();
        }

        // At last checking prototypes as good as we can
        if (!(x instanceof Object && y instanceof Object)) {
            return false;
        }

        if (x.isPrototypeOf(y) || y.isPrototypeOf(x)) {
            return false;
        }

        if (x.constructor !== y.constructor) {
            return false;
        }

        if (x.prototype !== y.prototype) {
            return false;
        }

        // Check for infinitive linking loops
        if (leftChain.indexOf(x) > -1 || rightChain.indexOf(y) > -1) {
            return false;
        }

        // Quick checking of one object being a subset of another.
        // todo: cache the structure of arguments[0] for performance
        for (p in y) {
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                return false;
            }
            else if (typeof y[p] !== typeof x[p]) {
                return false;
            }
        }

        for (p in x) {
            if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                return false;
            }
            else if (typeof y[p] !== typeof x[p]) {
                return false;
            }

            switch (typeof (x[p])) {
                case 'object':
                case 'function':

                    leftChain.push(x);
                    rightChain.push(y);

                    if (!compare2Objects(x[p], y[p])) {
                        return false;
                    }

                    leftChain.pop();
                    rightChain.pop();
                    break;

                default:
                    if (x[p] !== y[p]) {
                        return false;
                    }
                    break;
            }
        }

        return true;
    }

    if (arguments.length < 1) {
        return true; //Die silently? Don't know how to handle such case, please help...
        // throw "Need two or more arguments to compare";
    }

    for (i = 1, l = arguments.length; i < l; i++) {

        leftChain = []; //Todo: this can be cached
        rightChain = [];

        if (!compare2Objects(arguments[0], arguments[i])) {
            return false;
        }
    }

    return true;
}

export function manageNotificationsPermissions() {
    if ("Notification" in window) {
        var permission = Notification.permission;

        if (permission === "denied" || permission === "granted") {
            return;
        }

        Notification.requestPermission();
    }
}

export function formatBytesToSize(bytes) {
    var sizes = ['octets', 'ko', 'mo', 'go', 'to'];
    if (bytes == 0) return '0 octets';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}
